import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb.jsx';
import { regionTerms } from '../lib/regions.js';

// List view: one state's county table. (The map lives on its own tab.)
export default function CountyList() {
  const { state } = useParams();
  const navigate = useNavigate();
  const [counties, setCounties] = useState(null);
  const [error, setError] = useState(null);
  const [query, setQuery] = useState('');

  useEffect(() => {
    setCounties(null);
    setError(null);
    fetch(`/api/states/${state}/counties`)
      .then((res) => {
        if (!res.ok) return res.json().then((body) => Promise.reject(new Error(body.error || `HTTP ${res.status}`)));
        return res.json();
      })
      .then(setCounties)
      .catch((err) => setError(err.message));
  }, [state]);

  const rows = useMemo(() => {
    if (!counties) return [];
    const q = query.trim().toLowerCase();
    const list = q ? counties.filter((c) => c.name.toLowerCase().includes(q)) : counties;
    return [...list].sort((a, b) => a.name.localeCompare(b.name));
  }, [counties, query]);

  return (
    <div className="app">
      <Breadcrumb items={[{ label: 'All states', to: '/list' }, { label: state.toUpperCase() }]} />
      <header className="masthead">
        <div>
          <h1>{state.toUpperCase()}</h1>
          <p className="sub">Select a county to see live conditions</p>
        </div>
      </header>

      {error && (
        <div className="banner err">
          <strong>Could not load counties.</strong> {error}
        </div>
      )}

      {!counties && !error && <div className="loading">Loading counties…</div>}

      {counties && (
        <>

          <div className="controls">
            <input
              className="search"
              placeholder="Filter by county…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <div className="spacer" />
            <span className="muted" style={{ fontSize: 12 }}>
              {rows.length} of {counties.length} counties
            </span>
          </div>

          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th className="left">{regionTerms(state).county}</th>
                  <th>{regionTerms(state).country === 'CA' ? 'Municipalities' : 'ZIP codes'}</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((c) => (
                  <tr key={c.slug} onClick={() => navigate(`/${state}/${c.slug}`)}>
                    <td className="left">{c.name}</td>
                    <td>{c.zipCount.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
